import { useEffect } from 'react';

export default function MetaTags() {
  useEffect(() => {
    // Add Google Analytics verification meta tag
    const meta = document.createElement('meta');
    meta.name = 'google-site-verification';
    meta.content = 'G-XXNVCH52SE';
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return null;
} 